import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { slot: "breadcrumbs" }
const _hoisted_2 = {
  dsf_level: "s-medium",
  class: "dsf-hidden-mobile"
}
const _hoisted_3 = {
  dsf_level: "s-semibold",
  class: "dsf-hidden-tablet dsf-hidden-desktop"
}
const _hoisted_4 = {
  slot: "navigation",
  dsf_gap: "l"
}

import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'

import { i18n } from '@/services/i18n'
import NotificationsInbox from '@/notifications/NotificationsInbox.vue'
import ProfileMenu from './ProfileMenu.vue'
import { ONBOARDING_ROUTE_NAME } from '@/config/routes'
import { analytics } from '@/services/analyticsProvider'
import { ANALYTICS_EVENTS } from '@/services/analyticsEvents'
import { useFaqUrl } from '@/components/sennderUrlHelper'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLayoutHeaderNew',
  emits: ['mobile-menu-click'],
  setup(__props) {



const route = useRoute()

const headerText = computed(() => {
  if (route.name === ONBOARDING_ROUTE_NAME) {
    return ''
  }
  const key = `${String(route.name).toLowerCase()}.headline`
  return i18n.global.t(key)
})

const isHelpOpen = ref(false)

const faqUrl = useFaqUrl()

const navigateToFaq = () => {
  isHelpOpen.value = false
  window.open(faqUrl.value, '_blank')
  analytics.trackEvent(ANALYTICS_EVENTS.MENU_FAQ_CLICK)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("dsf-text", _hoisted_2, _toDisplayString(headerText.value), 1 /* TEXT */),
      _createElementVNode("dsf-text", _hoisted_3, _toDisplayString(headerText.value), 1 /* TEXT */)
    ]),
    _createElementVNode("dsf-row", _hoisted_4, [
      _createVNode(NotificationsInbox),
      _createElementVNode("dsf-icon-button", {
        dsf_icon: "HelpCircle",
        dsf_size: "small",
        dsf_title: "FAQ",
        class: "dsf-hidden-mobile",
        onClick: navigateToFaq
      }),
      _createCommentVNode(" Desktop profile "),
      _createVNode(ProfileMenu, { class: "dsf-hidden-mobile" }),
      _createCommentVNode(" Mobile navigation "),
      _createElementVNode("dsf-icon-button", {
        id: "hamburger",
        dsf_icon: "Menu",
        dsf_size: "medium",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('mobile-menu-click'))),
        class: "dsf-hidden-tablet dsf-hidden-desktop"
      })
    ])
  ]))
}
}

})